import React, { useState } from "react";
import axios from "axios";
import rv400Image from "../resource/avangerbg.png";
import { FaStar, FaRedo, FaPlay } from "react-icons/fa";
import { State, City } from "country-state-city";
import { Loader2, Sparkles, CheckCircle } from "lucide-react";
import kgvHero from '../resource/kgvhero1.png';
import bike18 from '../resource/bike18.png';
import bike12 from '../resource/bike12.png';
import bike11 from '../resource/bike11.png';
import bike13 from '../resource/bike13.png';
import bike14 from '../resource/bike14.png';
import bike15 from '../resource/bike15.png';
import bike16 from '../resource/bike17.png';
import BikeVideo from "../resource/hii.mp4";

const KgvbikeOrder = () => {
  const [availableCities, setAvailableCities] = useState([]);
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [show360View, setShow360View] = useState(false);
  const [rotation360, setRotation360] = useState(0);
  const INDIA_CODE = "IN";
  const [dealerEmail, setDealerEmail] = useState("");

  // Image gallery array
  const bikeImages = [bike13, bike12, bike18, bike11, bike15, bike16];

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    idProof: "Aadhar",
    idNumber: "",
    country: "India",
    state: "",
    city: "",
    color: "",
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState("");

  const sendBikeOtp = async () => {
    setOtpLoading(true);
    setOtpError("");
    try {
      const cleanPhone = formData.phone.replace(/\s+/g, "");
      const res = await axios.post("https://auth.kgvl.co.in/api/otp/send", { phone: cleanPhone });
      if (res.data.success) {
        setOtpSent(true);
      } else {
        setOtpError(res.data.message || "Failed to send OTP");
      }
    } catch (err) {
      setOtpError(err.response?.data?.message || err.message || "Error sending OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyBikeOtp = async () => {
    setOtpLoading(true);
    setOtpError("");
    try {
      const cleanPhone = formData.phone.replace(/\s+/g, "");
      const res = await axios.post("https://auth.kgvl.co.in/api/otp/verify", { phone: cleanPhone, otp: otpCode });
      if (res.data.success) {
        setOtpVerified(true);
      } else {
        setOtpError(res.data.message || "Invalid OTP");
      }
    } catch (err) {
      setOtpError(err.response?.data?.message || err.message || "Invalid OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const colorOptions = ["RED", "BLUE", "BLACK"];
  const colorMap = {
    RED: "bg-red-600",
    BLUE: "bg-blue-600",
    BLACK: "bg-black",
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLocationChange = async (field, value) => {
    const apiUrl = 'https://auth.kgvl.co.in';
    if (field === "state") {
      setFormData((prev) => ({
        ...prev,
        state: value,
        city: "",
        branch: "",
      }));
      try {
        const allCities = City.getCitiesOfState(INDIA_CODE, value);
        setAvailableCities(allCities);
      } catch (err) {
        console.error("Failed to fetch cities:", err);
        setAvailableCities([]);
      }
    } else if (field === "city") {
      setFormData((prev) => ({
        ...prev,
        city: value,
        branch: value,
      }));

      try {
        const encodedCity = encodeURIComponent(value);
        const response = await fetch(
          `${apiUrl}/dealer/email/${encodedCity}`
        );

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.dealerEmail) {
            setDealerEmail(data.dealerEmail);
          } else {
            setDealerEmail("");
          }
        } else {
          setDealerEmail("");
        }
      } catch (err) {
        console.error("Error fetching dealer email:", err);
        setDealerEmail("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    if (!otpVerified) {
      setMessage("❌ Please verify your mobile number first.");
      setLoading(false);
      return;
    }

    if (!formData.color) {
      setMessage("❌ Please select a color before submitting.");
      setLoading(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    console.log("Submitting order data:", formData);

    try {
      const res = await axios.post(
        "https://auth.kgvl.co.in/api/kgvbikeorder",
        formData
      );
      setMessage("✅ Order placed successfully!");
      if (window.fbq) {
        window.fbq("track", "Lead", {
          content_name: "KGV E-Hybrid Bike",
          content_category: "Vehicle",
          value: 124000,
          currency: "INR"
        });
      }
      setFormData({
        name: "",
        phone: "",
        email: "",
        idProof: "Aadhar",
        idNumber: "",
        country: "India",
        state: "",
        city: "",
        color: "",
      });
      setOtpVerified(false);
      setOtpSent(false);
      setOtpCode("");
      setAvailableCities([]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error("Order submission error:", error);
      const errorMsg = error.response?.data?.message || "Failed to place order. Please try again.";
      setMessage(`❌ ${errorMsg}`);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % bikeImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + bikeImages.length) % bikeImages.length);
  };

  const handle360Drag = (e) => {
    if (show360View && e.buttons === 1) {
      setRotation360((prev) => (prev + e.movementX) % 360);
      const imageIndex = Math.floor(((rotation360 + 360) % 360) / (360 / bikeImages.length));
      setCurrentImageIndex(imageIndex);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-8 sm:py-12 px-3 sm:px-4">
      <style>{`
        @keyframes shimmerSweep {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(100%); }
          100% { transform: translateX(100%); }
        }
        .shimmer-sweep {
          animation: shimmerSweep 3s infinite linear;
        }
      `}</style>
      {/* Product Display Section */}
      <div className="max-w-6xl mx-auto p-4 sm:p-6 md:p-8 grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10 items-start bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl border border-blue-100 mb-8 sm:mb-12">
        {/* Left Section */}
        <div className="flex flex-col items-center gap-4 sm:gap-6">
          {/* Main Image Display with Navigation */}
          <div className="relative w-full max-w-md mx-auto">
            <div className="absolute inset-0 bg-blue-200 rounded-xl blur-3xl opacity-20"></div>

            {showVideo ? (
              <div className="relative z-10 mx-auto bg-black rounded-lg sm:rounded-xl overflow-hidden shadow-xl sm:shadow-2xl w-full">
                <video
                  src={BikeVideo}
                  controls
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-auto max-h-[300px] sm:max-h-[500px]"
                >
                  Your browser does not support the video tag.
                </video>
                <button
                  onClick={() => setShowVideo(false)}
                  className="absolute top-2 sm:top-4 right-2 sm:right-4 bg-red-600 hover:bg-red-700 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg shadow-lg transition-all font-semibold z-30 text-sm sm:text-base"
                >
                  ✕ Close
                </button>
              </div>
            ) : show360View ? (
              <div className="relative z-10 mx-auto w-full">
                <div
                  className="cursor-grab active:cursor-grabbing select-none"
                  onMouseMove={handle360Drag}
                >
                  <img
                    src={bikeImages[currentImageIndex]}
                    alt="KGV Hybrid Bike 360 View"
                    className="w-full rounded-lg sm:rounded-xl shadow-lg sm:shadow-2xl"
                    draggable="false"
                  />
                  {/* 360 Indicator */}
                  <div className="absolute top-2 sm:top-4 left-1/2 -translate-x-1/2 bg-blue-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold shadow-lg flex items-center gap-2">
                    <FaRedo className="animate-spin text-sm sm:text-base" />
                    360° View - Drag to Rotate
                  </div>
                </div>
                <button
                  onClick={() => {
                    setShow360View(false);
                    setRotation360(0);
                  }}
                  className="absolute top-2 sm:top-4 right-2 sm:right-4 bg-white/90 hover:bg-white text-gray-800 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg shadow-lg transition-all font-semibold z-30 text-sm sm:text-base"
                >
                  ✕ Exit 360°
                </button>
              </div>
            ) : (
              <>
                <img
                  src={bikeImages[currentImageIndex]}
                  alt="KGV Hybrid Bike"
                  className="w-full rounded-lg sm:rounded-xl shadow-lg sm:shadow-2xl relative z-10 mx-auto"
                />

                {/* Navigation Arrows */}
                <button
                  onClick={prevImage}
                  className="absolute left-1 sm:left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 sm:p-3 rounded-full shadow-lg transition-all z-20 text-lg sm:text-2xl active:scale-95"
                >
                  ‹
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-1 sm:right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 sm:p-3 rounded-full shadow-lg transition-all z-20 text-lg sm:text-2xl active:scale-95"
                >
                  ›
                </button>

                {/* Image Counter */}
                <div className="absolute bottom-2 sm:bottom-4 right-2 sm:right-4 bg-black/70 text-white px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs sm:text-sm z-20">
                  {currentImageIndex + 1} / {bikeImages.length}
                </div>
              </>
            )}
          </div>

          {/* Thumbnail Gallery */}
          {!showVideo && !show360View && (
            <div className="flex gap-1.5 sm:gap-2 overflow-x-auto w-full pb-2">
              {bikeImages.map((img, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentImageIndex(idx)}
                  className={`flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 rounded-lg overflow-hidden border-2 transition-all ${currentImageIndex === idx
                    ? "border-blue-500 scale-105 sm:scale-110 shadow-lg"
                    : "border-gray-300 hover:border-blue-400"
                    }`}
                >
                  <img src={img} alt={`View ${idx + 1}`} className="w-full h-full object-cover" />
                </button>
              ))}
            </div>
          )}

          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mt-4 w-full">
            <button className="bg-gradient-to-r from-gray-100 to-gray-50 hover:from-gray-200 hover:to-gray-100 text-gray-700 px-3 sm:px-5 py-2 sm:py-2.5 rounded-lg shadow-md text-xs sm:text-sm font-medium transition-all active:scale-95">
              📷 Images ({bikeImages.length})
            </button>
            <button
              onClick={() => {
                setShow360View(true);
                setShowVideo(false);
              }}
              className="bg-gradient-to-r from-blue-100 to-blue-50 hover:from-blue-200 hover:to-blue-100 text-blue-700 px-3 sm:px-5 py-2 sm:py-2.5 rounded-lg shadow-md text-xs sm:text-sm font-medium flex items-center gap-1.5 sm:gap-2 transition-all active:scale-95"
            >
              <FaRedo className="text-xs sm:text-sm" /> 360° View
            </button>
            <button
              onClick={() => {
                setShowVideo(true);
                setShow360View(false);
              }}
              className="bg-gradient-to-r from-red-100 to-red-50 hover:from-red-200 hover:to-red-100 text-red-700 px-3 sm:px-5 py-2 sm:py-2.5 rounded-lg shadow-md text-xs sm:text-sm font-medium flex items-center gap-1.5 sm:gap-2 transition-all active:scale-95"
            >
              <FaPlay className="text-xs sm:text-sm" /> Watch Video
            </button>
          </div>

          {/* Color Selection */}
          <div className="w-full bg-gradient-to-br from-blue-50 to-indigo-50 p-4 sm:p-6 rounded-lg sm:rounded-xl border border-blue-100">
            <h3 className="text-xs sm:text-sm font-bold text-gray-700 mb-3 sm:mb-4 text-center">
              Choose Your Color
            </h3>
            <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
              {colorOptions.map((color) => {
                const isSelected = formData.color === color;
                return (
                  <button
                    key={color}
                    onClick={() => setFormData({ ...formData, color })}
                    aria-pressed={isSelected}
                    disabled={!otpVerified}
                    className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg text-xs sm:text-sm font-bold shadow-lg transition-all transform
                      border-2 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none
                      ${isSelected
                        ? `${colorMap[color]} text-white border-transparent ring-4 ring-offset-2 scale-100 sm:scale-105`
                        : "bg-white text-gray-800 border-gray-300 hover:border-gray-400 hover:shadow-xl hover:scale-100 sm:hover:scale-105"
                      }`}
                  >
                    {color}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="space-y-4 sm:space-y-6">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            KGV E-Hybrid Bike
          </h1>

          <div className="flex items-center gap-2 sm:gap-3 text-yellow-500 font-semibold text-base sm:text-lg">
            <FaStar className="text-base sm:text-xl" />
            4.1/5{" "}
            <span className="text-xs sm:text-sm text-blue-600 hover:underline cursor-pointer">
              (607 reviews)
            </span>
          </div>

          <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
            The KGV E-Hybrid Bike is a smart blend of petrol and electric power, offering a
            range of up to 150 km on electric mode and backed by a 125cc engine. It's available
            in 3 stunning colors, with a top electric speed of 80 kmph, disc brakes front and
            rear, and a solid 130kg kerb weight — perfect for both daily commutes and
            adventurous rides.
            <br />
            <span className="group inline-flex items-center gap-3 bg-gradient-to-r from-indigo-600 to-blue-600 text-white px-4 py-1.5 rounded-full shadow-lg transition-all duration-300 hover:shadow-indigo-300/50 hover:scale-105 active:scale-95 cursor-default mt-4 border border-indigo-400/30 overflow-hidden relative">
              <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -rotate-45 shimmer-sweep"></span>
              <Sparkles className="w-3 h-3 text-indigo-200 animate-pulse" />
              <span className="text-[10px] sm:text-xs font-black tracking-wider uppercase">
                AI Intelligence Enhanced
              </span>
            </span>
          </p>

          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 sm:p-6 rounded-lg sm:rounded-xl border border-blue-200">
            <div className="text-2xl sm:text-3xl font-bold text-gray-900">
              ₹1.24 - 1.40 Lakh
            </div>
            <div className="text-xs sm:text-sm text-gray-600 mt-2 sm:mt-3">
              Ex-showroom Price in Delhi •{" "}
              <span className="text-blue-600 underline cursor-pointer hover:text-blue-700 font-medium">
                Change City
              </span>
            </div>
            <div className="text-xs sm:text-sm text-blue-600 mt-2 hover:underline cursor-pointer font-medium">
              Check On-Road Price »
            </div>
          </div>

          <div className="bg-green-50 border border-green-200 p-3 sm:p-4 rounded-lg">
            <div className="text-xs sm:text-sm text-gray-700">
              <span className="font-bold text-green-700">EMI starts @ ₹3,565</span> •{" "}
              <span className="text-blue-600 underline cursor-pointer hover:text-blue-700">
                Get EMI Offer
              </span>{" "}
              •{" "}
              <span className="text-blue-600 underline cursor-pointer hover:text-blue-700">
                EMI Calculator
              </span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 mt-4 sm:mt-6">
            <button className="bg-gradient-to-r from-red-600 to-red-700 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg hover:from-red-700 hover:to-red-800 transition-all shadow-lg font-semibold transform hover:scale-105 active:scale-95 text-sm sm:text-base">
              View July Offers
            </button>
            <button className="border-2 border-red-600 text-red-600 px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg hover:bg-red-50 transition-all shadow-md font-semibold transform hover:scale-105 active:scale-95 text-sm sm:text-base">
              Download Brochure
            </button>
          </div>
        </div>
      </div>

      {/* Order Form Section */}
      <div id="complete-your-order" className="bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-2xl p-4 sm:p-8 md:p-12 max-w-7xl mx-auto border border-blue-100">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6 sm:mb-8 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
          Complete Your Order
        </h2>

        {message && (
          <div
            className={`mb-4 sm:mb-6 p-3 sm:p-4 rounded-lg text-center font-semibold text-sm sm:text-base ${message.includes("✅")
              ? "bg-green-100 text-green-700 border border-green-300"
              : "bg-red-100 text-red-700 border border-red-300"
              }`}
          >
            {message}
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 md:gap-12">
          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
            <div>
              <label className="block mb-1.5 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-700">
                Full Name *
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={otpVerified}
                placeholder="Enter your full name"
                className="border-2 border-gray-200 w-full rounded-lg px-3 sm:px-4 py-2 sm:py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block mb-1.5 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-700">
                Phone Number *
              </label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                disabled={otpVerified}
                placeholder="Enter 10-digit mobile number"
                className="border-2 border-gray-200 w-full rounded-lg px-3 sm:px-4 py-2 sm:py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            {/* OTP Verification UI */}
            {!otpVerified && (
              <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg space-y-3">
                {!otpSent ? (
                  <button
                    type="button"
                    onClick={sendBikeOtp}
                    disabled={otpLoading || !/^[6-9]\d{9}$/.test(formData.phone.replace(/\s+/g, ""))}
                    className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-2 px-4 rounded-lg transition duration-200 text-sm flex items-center justify-center gap-2"
                  >
                    {otpLoading ? <Loader2 className="w-4 h-4 animate-spin text-white" /> : "Send OTP"}
                  </button>
                ) : (
                  <div className="space-y-3">
                    <p className="text-xs text-gray-500">An OTP has been sent to {formData.phone}. Please enter it below:</p>
                    <div className="flex gap-2">
                      <input
                        type="text"
                        maxLength={6}
                        placeholder="Enter 6-Digit OTP"
                        value={otpCode}
                        onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ""))}
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-800 placeholder-gray-400 text-sm focus:outline-none focus:border-blue-500"
                      />
                      <button
                        type="button"
                        onClick={verifyBikeOtp}
                        disabled={otpLoading || otpCode.length !== 6}
                        className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold px-4 py-2 rounded-lg transition duration-200 text-sm flex items-center justify-center"
                      >
                        {otpLoading ? <Loader2 className="w-4 h-4 animate-spin text-white" /> : "Verify"}
                      </button>
                    </div>
                    <div className="flex justify-between items-center text-xs">
                      <button
                        type="button"
                        onClick={sendBikeOtp}
                        disabled={otpLoading}
                        className="text-blue-600 hover:underline"
                      >
                        Resend OTP
                      </button>
                      {otpError && <span className="text-red-600 font-semibold">{otpError}</span>}
                    </div>
                  </div>
                )}
              </div>
            )}

            {otpVerified && (
              <div className="text-xs text-green-700 font-semibold flex items-center gap-1.5 bg-green-50 border border-green-200 px-3 py-2.5 rounded-lg">
                <CheckCircle className="w-4 h-4 text-green-600" /> Phone Number Verified Successfully. You can now fill in the remaining details.
              </div>
            )}

            <div>
              <label className="block mb-1.5 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-700">
                Email Address *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={!otpVerified}
                placeholder="your.email@example.com"
                className="border-2 border-gray-200 w-full rounded-lg px-3 sm:px-4 py-2 sm:py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block mb-1.5 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-700">
                ID Proof Type *
              </label>
              <select
                name="idProof"
                value={formData.idProof}
                onChange={handleChange}
                required
                disabled={!otpVerified}
                className="border-2 border-gray-200 w-full rounded-lg px-3 sm:px-4 py-2 sm:py-3 bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
              >
                <option value="">-- Select ID Proof --</option>
                <option value="Aadhar">Aadhar Card</option>
                <option value="PAN">PAN Card</option>
                <option value="Driving License">Driving License</option>
              </select>
            </div>

            <div>
              <label className="block mb-1.5 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-700">
                ID Number *
              </label>
              <input
                type="text"
                name="idNumber"
                value={formData.idNumber}
                onChange={handleChange}
                required
                disabled={!otpVerified}
                placeholder="Enter your ID number"
                className="border-2 border-gray-200 w-full rounded-lg px-3 sm:px-4 py-2 sm:py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block mb-1.5 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-700">
                State *
              </label>
              <select
                name="state"
                value={formData.state}
                onChange={(e) => handleLocationChange("state", e.target.value)}
                required
                disabled={!otpVerified}
                className="border-2 border-gray-200 w-full rounded-lg px-3 sm:px-4 py-2 sm:py-3 bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
              >
                <option value="">-- Select State --</option>
                {State.getStatesOfCountry(INDIA_CODE).map((state) => (
                  <option key={state.isoCode} value={state.isoCode}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block mb-1.5 sm:mb-2 text-xs sm:text-sm font-semibold text-gray-700">
                City *
              </label>
              <select
                name="city"
                value={formData.city}
                onChange={(e) => handleLocationChange("city", e.target.value)}
                required
                disabled={!otpVerified || isLoadingCities || !formData.state}
                className="border-2 border-gray-200 w-full rounded-lg px-3 sm:px-4 py-2 sm:py-3 bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all disabled:bg-gray-100 disabled:cursor-not-allowed text-sm"
              >
                <option value="">
                  {isLoadingCities
                    ? "Loading cities..."
                    : !formData.state
                      ? "Select state first"
                      : "-- Select City --"}
                </option>
                {availableCities.map((city) => (
                  <option key={city.name} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
              {isLoadingCities && (
                <div className="flex items-center gap-2 mt-2 text-blue-600 text-xs sm:text-sm">
                  <Loader2 className="w-3 h-3 sm:w-4 sm:h-4 animate-spin" />
                  <span>Fetching available cities...</span>
                </div>
              )}
            </div>

            <button
              type="submit"
              disabled={loading || isLoadingCities || !otpVerified}
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-bold py-3 sm:py-4 rounded-lg shadow-lg transition-all transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none text-base sm:text-lg mt-4 sm:mt-6"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <Loader2 className="w-4 h-4 sm:w-5 sm:h-5 animate-spin" />
                  Submitting...
                </span>
              ) : (
                "Submit Order"
              )}
            </button>
          </form>

          {/* Image */}
          <div className="flex flex-col justify-center items-center bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg sm:rounded-2xl p-4 sm:p-8">
            <div className="relative w-full">
              <div className="absolute inset-0 bg-blue-200 rounded-full blur-3xl opacity-30 animate-pulse"></div>
              <img
                src={kgvHero}
                alt="KGV Hero"
                className="w-full h-auto max-h-[300px] sm:max-h-[500px] object-contain drop-shadow-2xl relative z-10"
              />
            </div>
            <div className="mt-6 sm:mt-8 text-center">
              <h3 className="text-lg sm:text-2xl font-bold text-gray-800 mb-2">
                Reserve Your Bike Today
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Join the hybrid revolution with KGV
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KgvbikeOrder;